// extracted by mini-css-extract-plugin
export default {"inlineLoader":"InlineLoader_inlineLoader__1BrFN","dot":"InlineLoader_dot__diOqx","dotFlashing":"InlineLoader_dotFlashing__lW3h+"};